// MedicalUnitsDynamic.tsx
import React from "react";

type Unit = {
  id?: string | number;
  title: string;
  text: string;
  icon: React.ReactNode; // <i className="bi bi-brain" />, <svg/>, <img/>...
};

type CTA = {
  label: string;
  href: string;
};

type MedicalUnitsProps = {
  /** Soldaki açık/beyaz başlık (örn: "Hastanemizin") */
  titleLight: string;
  /** Yeşil vurgulu başlık (örn: "Tıbbi Birimleri") */
  titleAccent: string;

  /** Birim listesi */
  units: Unit[];

  /** CTA butonu (opsiyonel) */
  cta?: CTA;

  /** Sütun sayısı (>=2). default=3 (responsive yine devrede) */
  columns?: number;

  /** true => kolonlar arasında dikey divider çizgisi göster */
  showDividers?: boolean;

  /** Arka plan (default: #2cadd2) */
  bgColor?: string;
  /** Vurgu (default: #2ba87a) */
  accentColor?: string;
  /** Metin rengi (default: #fff) */
  textColor?: string;

  /** Sağ üstte watermark isterse görsel URL (opsiyonel) */
  watermarkUrl?: string;
};

const MedicalUnits: React.FC<MedicalUnitsProps> = ({
  titleLight,
  titleAccent,
  units,
  cta,
  columns = 3,
  showDividers = true,
  bgColor = "#2cadd2",
  accentColor = "#2ba87a",
  textColor = "#ffffff",
  watermarkUrl,
}) => {
  // CSS var'ları inline style ile set ediyoruz
  const styleVars: React.CSSProperties = {
    // @ts-ignore – CSS custom property
    "--mu-bg": bgColor,
    "--mu-accent": accentColor,
    "--mu-fg": textColor,
    "--mu-divider": "rgba(255,255,255,.25)",
    "--mu-cols": String(Math.max(2, columns)), // min 2 sütun
    ...(watermarkUrl
      ? { 
          // @ts-ignore
          "--mu-watermark": `url("${watermarkUrl}")` 
        }
      : {}),
  };

  return (
    <section className="medical-units" style={styleVars}>
      <div className="container">
        <header className="mu-head">
          <h2 className="title">
            <span className="light">{titleLight}</span>
            <span className="green">{titleAccent}</span>
          </h2>
        </header>

        <div className="mu-cols">
          {units.map((u, i) => (
            <article
              key={u.id ?? i}
              className={`mu-item ${showDividers && i > 0 ? "" : ""}`}
            >
              <div className="mu-icon">{u.icon}</div>
              <h3 className="mu-name">{u.title}</h3>
              <p className="mu-text">{u.text}</p>
            </article>
          ))}
        </div>

        {cta && (
          <div className="mu-cta">
            <a className="btn-mu" href={cta.href}>
              {cta.label} <i className="bi bi-chevron-right" />
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

export default MedicalUnits;
